/* 2026-09-28 – vlastní rozbalovací nabídka pro „Seřadit podle“ ve stylu skleněných filtrů.
   Nativní <select> zůstává ve formuláři (skrytý) a dál posílá hodnotu; tahle nabídka ho jen ovládá.
   Důvod: Windows kreslí seznam možností nativního selectu po svém (bílý/modrý), nehodí se k webu. */
(() => {
  const SEL = 'select.facet-filters__sort';
  const CARET = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"/></svg>';
  let openHost = null;

  function closeAll(focusBtn) {
    if (!openHost) return;
    const btn = openHost.querySelector('.nv-rolet__btn');
    openHost.querySelector('.nv-rolet__list').hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) btn.focus();
    openHost = null;
  }

  function build(sel) {
    if (sel.dataset.nvRolet) return;
    sel.dataset.nvRolet = '1';
    const host = sel.closest('.select') || sel.parentElement;
    host.classList.add('nv-rolet-host');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nv-rolet__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    const label = document.querySelector('label[for="' + sel.id + '"]');
    if (label) btn.setAttribute('aria-label', label.textContent.trim().replace(/:$/, ''));

    const list = document.createElement('ul');
    list.className = 'nv-rolet__list';
    list.setAttribute('role', 'listbox');
    list.id = sel.id + '-nv-list';
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);
    [...sel.options].forEach((o, i) => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.id = list.id + '-' + i;
      li.tabIndex = -1;
      li.dataset.value = o.value;
      li.textContent = o.textContent.trim();
      list.appendChild(li);
    });

    const sync = () => {
      const o = sel.options[sel.selectedIndex];
      btn.innerHTML = '<span>' + (o ? o.textContent.trim() : '') + '</span>' + CARET;
      list.querySelectorAll('li').forEach(li => li.setAttribute('aria-selected', li.dataset.value === sel.value ? 'true' : 'false'));
    };
    sync();
    host.appendChild(btn);
    host.appendChild(list);

    const open = () => {
      closeAll(false);
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      openHost = host;
      (list.querySelector('[aria-selected="true"]') || list.firstElementChild).focus();
    };
    const choose = li => {
      if (sel.value !== li.dataset.value) {
        sel.value = li.dataset.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      closeAll(true);
    };

    btn.addEventListener('click', () => (list.hidden ? open() : closeAll(false)));
    btn.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('click', e => { const li = e.target.closest('li'); if (li) choose(li); });
    list.addEventListener('keydown', e => {
      const items = [...list.children];
      const i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) choose(items[i]); }
      else if (e.key === 'Escape') { e.preventDefault(); closeAll(true); }
      else if (e.key === 'Tab') { closeAll(false); }
    });
    sel.addEventListener('change', sync);
  }

  document.addEventListener('click', e => { if (openHost && !openHost.contains(e.target)) closeAll(false); });
  const init = () => document.querySelectorAll(SEL).forEach(build);
  init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });   // filtry se překreslují přes AJAX
})();
